import { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import axios from "axios";
import { routes } from "./General";
import Select from "react-select";
import { BlkField } from "../coms/BlkField";
import { useDispatch, useSelector } from "react-redux";
import { do_login } from "../sec/actions";
import { useDebounce } from "../custom-hooks/useDebounce";

export const ComboAsegurado = ({ setFieldValue, name, alert, values }) => {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const [client, setClient] = useState({});
    const [clients, setClients] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [text, setText] = useState("");
    const textDebounced = useDebounce(text, 400);

    useEffect(() => {
        if (!values) setClient(null);
    }, [values]);

    useEffect(() => {
        getClients(textDebounced);
    }, [textDebounced]);

    const getClients = value => {
        if (!value.length) {
            setClients([]);
            return;
        }
        setIsLoading(() => true);
        axios
            .get(routes.apiGen + "/aseguradosvam", { params: { cedula: value.toUpperCase() } })
            .then(resp => {
                let data = resp.data;
                data.forEach(p => {
                    p.label = p.cedula + " - " + p.nmCliente + " " + (p.apCliente ? p.apCliente : "");
                    p.value = p.cedula;
                });
                data.sort((p1, p2) => p1.cedula.localeCompare(p2.cedula));
                setClients(data);
            })
            .catch(error => {
                alert.current.show_error("Error al consultar " + error);
            })
            .finally(() => setIsLoading(() => false));
    };

    const handleCedula = cedula => {
        const current = alert.current;
        if (cedula !== "") {
            let usuario = JSON.parse(JSON.stringify(user));
            usuario.cedula = cedula;
            dispatch(do_login({ ...usuario }));
        } else {
            current.show_error("Sin cédula");
        }
    };

    return (
        <Row>
            <Col>
                <div>
                    <Label>Titular: </Label>
                    <BlkField
                        name={name}
                        component={Select}
                        value={client}
                        options={clients}
                        onInputChange={setText}
                        placeholder="Cliente"
                        onChange={e => {
                            setFieldValue(name, e.value);
                            setClient(e);
                            handleCedula(e.value);
                        }}
                        classNamePrefix="react-select"
                        className="react-select"
                        noOptionsMessage={() => (isLoading ? "Loading..." : "No options")}
                    />
                </div>
            </Col>
        </Row>
    );
};
